import type { AssetRopaReviewStatus } from 'config/api/ropaReviews/ropaReviews.types';

import type { AssetRopaOwnerFilterCompleteness, AssetRopaOwnerFilterGdprRelevance } from './assetRopaOwnerFilter.types';

export type AssetRopaBooleanFilterValue = '' | 'true' | 'false';

/** UI filter values shared by owner workspace and review pages. */
export type AssetRopaDpiaFilterState = '' | 'indicated' | 'required_unapproved' | 'none';

export type AssetRopaOwnerDpiaFilterState = '' | 'indicated' | 'none';

export type AssetRopaFilterPaginationOptions = {
  page?: number;
  pageSize?: number;
};

export type AssetRopaSharedFilterFields = {
  search: string;
  assetTypeId: '' | number;
  sensitivePersonalData: AssetRopaBooleanFilterValue;
  thirdCountryProcessing: AssetRopaBooleanFilterValue;
};

export type AssetRopaReviewFilters = AssetRopaSharedFilterFields & {
  reviewStatus: '' | AssetRopaReviewStatus;
  operationalOwnerMembershipId: '' | number;
  warningState: '' | 'with_warnings' | 'no_warnings';
  dpiaState: AssetRopaDpiaFilterState;
};

export const DEFAULT_ASSET_ROPA_REVIEW_FILTERS: AssetRopaReviewFilters = {
  search: '',
  reviewStatus: '',
  assetTypeId: '',
  operationalOwnerMembershipId: '',
  warningState: '',
  dpiaState: '',
  sensitivePersonalData: '',
  thirdCountryProcessing: '',
};

export type OwnerWorkspaceFilters = AssetRopaSharedFilterFields & {
  completeness: '' | AssetRopaOwnerFilterCompleteness;
  gdprRelevance: AssetRopaOwnerFilterGdprRelevance;
  dpiaState: AssetRopaOwnerDpiaFilterState;
};

export const DEFAULT_OWNER_WORKSPACE_FILTERS: OwnerWorkspaceFilters = {
  search: '',
  assetTypeId: '',
  completeness: '',
  gdprRelevance: 'currently_indicated',
  dpiaState: '',
  sensitivePersonalData: '',
  thirdCountryProcessing: '',
};
